import { RoutePath } from "#src/utils/route";
import { WorkerRunsRoutePath } from "..";

/**
 * Detail route for a single worker run.
 * Resolves to /app/workers/runs/:runId.
 */
export const WorkerRunDetailRoutePath = WorkerRunsRoutePath.concat(
  new RoutePath<"runId">({
    path: "/:runId",
    title: "Worker run",
  })
);
